import { useCallback, useState } from 'react';
import { UseFormGetValues } from 'react-hook-form';
import {
  IWebsiteGraderUserDetails,
  useWebsiteGraderContext,
  WebsiteGraderStep,
} from 'src/components/providers/websiteGrader';
import { Logger } from 'src/utils/Logger';
import useGATracking from 'src/hooks/google/useGATracking';

type ReturnType = {
  disabled: boolean;
  onSubmit: () => void;
};

export const useSubmitUserDetailsForm = (getValues: UseFormGetValues<IWebsiteGraderUserDetails>): ReturnType => {
  const [disabled, setDisabled] = useState(false);
  const context = useWebsiteGraderContext();
  const { pushCustomGAEvent } = useGATracking({ triggerOnMount: false });

  const onSubmit = useCallback(() => {
    setDisabled(true);
    const websiteGraderUserDetails = (
      ['firstName', 'lastName', 'phone', 'email'] as (keyof IWebsiteGraderUserDetails)[]
    ).reduce(
      (userDetails, fieldName) => ({
        ...userDetails,
        [fieldName]: getValues(fieldName),
      }),
      {} as IWebsiteGraderUserDetails
    );

    pushCustomGAEvent({
      gaEventCategory: 'WebsiteGrader',
      gaEventAction: 'Submit',
      gaEventLabel: 'WebsiteGraderUserDetails',
      buttonId: 'website-grader-collect-user-details-next',
    });

    Logger.trace('onSubmit:websiteGraderUserDetails', { websiteGraderUserDetails }, 'useSubmitUserDetailsForm');
    context.setUserDetails({ ...websiteGraderUserDetails });
    context.setCurrentStep(WebsiteGraderStep.COLLECT_BUSINESS_DETAILS);
  }, [context]);

  return { disabled, onSubmit };
};
